import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import _ from 'lodash';
import API from '../common/API';
import * as Actions from '../actions/CommonOptions';
import { waitAuthorizedCheck } from './Auth';

function* getListOptions(action) {
    const endpoint = action?.payload?.language
        ? `/api/v1/settings/options/?language=${action.payload.language}`
        : '/api/v1/settings/options/';
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
            },
        );
        yield put(Actions.GetListOptionsReceived(response));
    } catch (error) {
        yield put(Actions.GetListOptionsReceiveFailure(yield error));
    }
}

function* getJobs(action) {
    const endpoint = `/api/v1/event/${_.isString(action.payload) ? action.payload : action.payload.shortName}/jobs/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {
                    role: action.payload.role,
                    ...{ ...action.payload?.language && { language: action.payload.language } },
                },
            },
        );
        yield put(Actions.GetJobsRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetJobsRequestedReceivedFailure(yield error));
    }
}

function* getZones(action) {
    const endpoint = action.payload.language
        ? `/api/v1/event/${_.isString(action.payload) ? action.payload : action.payload.shortName}/zone/?language=${action.payload.language}`
        : `/api/v1/event/${_.isString(action.payload) ? action.payload : action.payload.shortName}/zone/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
            },
        );
        yield put(Actions.GetZonesRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetZonesRequestedReceivedFailure(yield error));
    }
}

function* getZonesStatus(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/zone/status/?zone_ids=${action.payload}`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.GetZonesStatusReceived(response));
    } catch (error) {
        yield put(Actions.GetZonesStatusFailure(yield error));
    }
}

function* getOccupation(action) {
    const endpoint = `/api/v1/event/${action.payload.shortName}/occupations/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {
                    role: action.payload.role,
                    ...{ ...action.payload?.language && { language: action.payload.language } },
                },
            },
        );
        yield put(Actions.GetOccupationReceived(response));
    } catch (error) {
        yield put(Actions.ClearOccupation(yield error));
    }
}

function* getCategory(action) {
    const endpoint = `/api/v1/event/${_.isString(action.payload) ? action.payload : action.payload.shortName}/category/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {
                    role: action.payload.role,
                    ...{ ...action.payload?.language && { language: action.payload.language } },
                },
            },
        );
        yield put(Actions.GetCategoryReceived(response));
    } catch (error) {
        yield put(Actions.GetCategoryFailure(yield error));
    }
}


export default function* AdminEventManagement() {
    yield all([
        takeLatest('GET_LIST_OPTIONS_REQUESTED', getListOptions),
        takeLatest('GET_JOBS_REQUESTED', getJobs),
        takeLatest('GET_ZONES_REQUESTED', getZones),
        takeLatest('GET_ZONES_STATUS_REQUESTED', getZonesStatus),
        takeLatest('GET_OCCUPATION_REQUEST', getOccupation),
        takeLatest('GET_CATEGORY_REQUEST', getCategory),
    ]);
}
